export function getDisplayProfileName(profileName: string | null): string {
  if (!profileName) return 'Unknown';
  if (profileName === 'Virtual') return 'Cloud Connector';
  return profileName;
}

export function getProfileColorClass(profileName: string | null): string {
  const profile = getDisplayProfileName(profileName);
  switch (profile) {
    case 'Edge':
      return 'dls-bg-status-info/15 dls-text-status-info';
    case 'Cloud Connector':
      return 'dls-bg-neeve-tertiary/20 dls-text-neeve-primary';
    case 'Virtual Edge':
      return 'dls-bg-status-online-quarternary dls-text-status-online';
    default:
      return 'dls-bg-neutral-quarternary dls-text-neutral';
  }
}
